import type { ReactNode } from "react";

const TONES = {
  hipaa: "bg-hipaa-bg text-hipaa-fg",
  "needs-client": "bg-status-needs-client-bg text-status-needs-client-fg",
  "in-progress": "bg-status-in-progress-bg text-status-in-progress-fg",
  logged: "bg-status-logged-bg text-status-logged-fg",
  neutral: "border border-line text-muted",
} as const;

export type BadgeTone = keyof typeof TONES;

/** A small rounded label (section 11.0: fully rounded; text, never color alone). */
export function Badge({ tone, children }: { tone: BadgeTone; children: ReactNode }) {
  return (
    <span
      className={`inline-flex items-center self-start rounded-pill px-2 py-[3px] text-[10.5px] font-bold tracking-[0.05em] ${TONES[tone]}`}
    >
      {children}
    </span>
  );
}

/**
 * Section 14.4: a block for a HIPAA client says so. On Axon blue (a selected
 * card) it sits on the card's own surface: in dark its tint alone, over the
 * blue, read at 3.04:1 (#243).
 */
export function HipaaBadge({ onBrand = false }: { onBrand?: boolean }) {
  const badge = <Badge tone="hipaa">HIPAA</Badge>;
  return onBrand ? <span className="inline-flex self-start rounded-pill bg-card">{badge}</span> : badge;
}
